import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils.js'
import { AnimatePresence, motion } from 'framer-motion'

export const AnimatedCheckbox: React.FC<{
  state: 'done' | 'skip' | 'empty' | 'fail'
  onClick: () => void
}> = ({ state, onClick }) => {
  const [isIconVisible, setIsIconVisible] = useState(state === 'skip')

  useEffect(() => {
    if (isIconVisible) {
      const timerId = setTimeout(() => {
        setIsIconVisible(false)
      }, 2000)
      return () => clearTimeout(timerId)
    }
  }, [isIconVisible, state])

  return (
    <button
      style={{
        transitionTimingFunction: 'cubic-bezier(0.18, 0.89, 0.32, 1.28)',
      }}
      className={cn(
        'h-8 w-8 cursor-pointer select-none rounded text-white transition-transform duration-300',
        {
          'bg-green-400': state === 'done',
          'scale-90 transform bg-gray-400': state === 'skip',
          'scale-75 transform bg-gray-300': state === 'empty',
        },
      )}
      onClick={() => {
        onClick()

        setTimeout(() => {
          setIsIconVisible(true)
        }, 50)
      }}
    >
      <AnimatePresence>
        {(state === 'skip' || isIconVisible) && (
          <svg
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <motion.path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={
                state === 'done'
                  ? 'M5 13l4 4L19 7'
                  : state === 'skip'
                    ? 'M9 5l7 7-7 7'
                    : 'M6 18L18 6M6 6l12 12'
              }
              initial={{
                pathLength: 0,
                opacity: 0.5,
              }}
              animate={{
                pathLength: 1,
                opacity: 1,
              }}
              exit={{
                pathLength: 0,
                opacity: 0.5,
                transition: { duration: 0.15 },
              }}
            />
          </svg>
        )}
      </AnimatePresence>
    </button>
  )
}
